$(document).on('ready turbolinks:load', function() {
  const $buttonBack = $('.button-back');

  $buttonBack.on('click', function () {
    window.history.back();
  });
});
